/** An editor meant for comment posting, with the addition of some hints for starting a conversation */ import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React, { useCallback, useState } from 'react';
import CommentBox from '../CommentBox';
import EditorView from './views/EditorView';
import { useCommentSuggestions } from './hooks/useCommentSuggestions';
const CommentBoxWithSuggestions = /*#__PURE__*/ React.forwardRef((_param, ref)=>{
    var { type, nc, autoFocus, onClose, onPost, footerClassName, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy } = _param, rest = _object_without_properties(_param, [
        "type",
        "nc",
        "autoFocus",
        "onClose",
        "onPost",
        "footerClassName",
        'aria-label',
        'aria-labelledby'
    ]);
    const [editorApi, setEditorApi] = useState();
    const [editorState, setEditorState] = useState();
    const { forceEditorLoad, submitValidator, suggestions, maxVisible, onSuggestionSelect } = useCommentSuggestions(type, editorApi, editorState);
    const handleEditorReady = useCallback((_, api)=>setEditorApi(api), []);
    const handleEditorChange = useCallback((newState)=>setEditorState(newState), []);
    return /*#__PURE__*/ React.createElement(CommentBox, _object_spread({
        forceLoadOnMount: forceEditorLoad,
        onEditorReady: handleEditorReady,
        onEditorChange: handleEditorChange,
        submitValidator: submitValidator,
        editorView: /*#__PURE__*/ React.createElement(EditorView, {
            nc: nc,
            onCancel: onClose,
            onPost: onPost,
            footerClassName: footerClassName,
            "aria-label": ariaLabel,
            "aria-labelledby": ariaLabelledBy,
            suggestions: suggestions,
            maxVisible: maxVisible,
            onSuggestionSelect: onSuggestionSelect
        }),
        ref: ref
    }, rest));
});
CommentBoxWithSuggestions.displayName = 'CommentBoxWithSuggestions';
export default CommentBoxWithSuggestions;
